define('app/models/organizational_registeration',['app/setup'], function(takhfifan) {
  takhfifan.OrganizationalRegistration = Backbone.Model.extend({

    validation: {
      'fullname': {
          required: true,
          msg: i18n.t('full_name_missing')
      },
      // 'lastname': {
      //     required: true,
      //     msg: i18n.t('last_name_missing')
      // },
      'email': [{
          required: true,
          msg: i18n.t('email_missing')
        }, {
          pattern: 'email',
          msg: i18n.t('email_invalid')
      }],
      'invitecode': {
          required: true,
          msg: i18n.t('invite_code_missing')
      },
      'organizational_identifier':  function (value, key, fields) {
        if(!_.isUndefined(fields.organizational_identifier)) {
          if(fields.organizational_identifier.length == 0) {
            return i18n.t('organizational_identifier_missing')
          }
        }
      },
      'password': {
        required: true,
        rangeLength: [6,50],
        pattern: /^\S{6,50}$/,
        msg: i18n.t('password_invalid')
      },
      // 'confirmation': {
      //   equalTo: 'password',
      //   msg: i18n.t('password_different')
      // },
      // 'telephone': function (value, key, fields) {
      //   var pat = new RegExp(/(09)[123]\d+$/);
      //     if(!pat.test(value) && value.length != 0) {
      //       return i18n.t('telephone_invalid')
      //     }
      //     else if(value.length > 0 && value.length != 11) {
      //       return i18n.t('telephone_range')
      //     }
      //     else if(value.length == '' && fields.phoneNumberRequirement != 'optional'){
      //       return i18n.t('telephone_missing')
      //     }
      // },
      'accepted_privacy_policy': function (value, key, fields) {
        if (!fields['accepted_privacy_policy']) {
          return i18n.t('privacy_policy_missing');
        }
      }
    },

    register: function() {
      var remove = ['submitUrl', 'need_suburb', 'need_area'];
      var thisData = this.toJSON();

      _.each(remove, function(r) {
        delete thisData[r];
      });

      $.post(this.get('submitUrl'), thisData).done(function(data){
        if (!_.isNull(data.errors) && !_.isEmpty(data.errors)) {
          takhfifan.eventHub.trigger('customer:registrationError', data.errors);
        } else if (!_.isNull(data.name) && _.isString(data.name)) {
          takhfifan.eventHub.trigger('customer:login', {name: data.name});
          takhfifan.eventHub.trigger('customer:registered',{});
        }
      }).fail(function(data){
        takhfifan.eventHub.trigger(
          'customer:registrationError', [i18n.t('connection_error')]
        );
      });
    },

    defaults: {
      create_address: 1,
      default_billing: 1,
      default_shipping: 0,
      'street[]': '-',
      postcode: '-',
      country_id: 'IR',
      accepted_privacy_policy: false
    }

  });
});

